import {
  CustomerSearchQuery,
  CustomerType,
} from '@texas/api/endpoints/customersApi';
import { UserType } from '@texas/api/endpoints/userApi';
import { useCallback, useState } from 'react';

const defaultSearchQuery: CustomerSearchQuery = {
  searchTerm: '',
  includeArchived: false,
  sortBy: 'name',
  sortDesc: false,
  page: 1,
  pageSize: 24,
};

export function useCustomersDirectoryFilters() {
  const [searchQuery, setSearchQuery] =
    useState<CustomerSearchQuery>(defaultSearchQuery);

  const updateFilters = useCallback((filters: Partial<CustomerSearchQuery>) => {
    setSearchQuery((current) => ({ ...current, ...filters, page: 1 }));
  }, []);

  const setSearchTerm = useCallback(
    (searchTerm: string) => updateFilters({ searchTerm }),
    [updateFilters],
  );
  const setIncludeArchived = useCallback(
    (includeArchived: boolean) => updateFilters({ includeArchived }),
    [updateFilters],
  );
  const setScope = useCallback(
    (assignedToCurrentUser?: boolean) =>
      updateFilters({ assignedToCurrentUser }),
    [updateFilters],
  );
  const setCustomerType = useCallback(
    (type?: CustomerType) => updateFilters({ type }),
    [updateFilters],
  );
  const setCurrentUserRole = useCallback(
    (userType?: UserType | null) =>
      updateFilters({
        currentUserRole: userType === undefined ? undefined : { userType },
      }),
    [updateFilters],
  );
  const setSorting = useCallback((sortBy: string, sortDesc: boolean) => {
    setSearchQuery((current) => ({ ...current, sortBy, sortDesc }));
  }, []);
  const setPage = useCallback((page: number) => {
    setSearchQuery((current) => ({ ...current, page }));
  }, []);

  return {
    searchQuery,
    setCustomerType,
    setCurrentUserRole,
    setIncludeArchived,
    setPage,
    setScope,
    setSearchTerm,
    setSorting,
  };
}
